import type { ChargebacksAvailability } from "@redotech/redo-onboarding-api/schema/chargebacks/chargebacks-config";
import type { AdminConfig } from "@redotech/redo-onboarding-api/schema/get-progress";
import type { OrderEditingAvailability } from "@redotech/redo-onboarding-api/schema/order-editing/order-editing-config";
import type { RecoverAvailability } from "@redotech/redo-onboarding-api/schema/recover/recover-config";
import type { ReturnsAvailability } from "@redotech/redo-onboarding-api/schema/returns/returns-config";
import type { ShippingFulfillmentAvailability } from "@redotech/redo-onboarding-api/schema/shipping-fulfillment/shipping-fulfillment-config";
import { createContext, useContext } from "react";

export interface ProductConfig {
  chargebacks?: ChargebacksAvailability;
  orderEditing?: OrderEditingAvailability;
  recover?: RecoverAvailability;
  returns?: ReturnsAvailability;
  shippingFulfillment?: ShippingFulfillmentAvailability;
  adminConfig?: AdminConfig;
}

export const ProductConfigContext = createContext<ProductConfig>({});

export function useProductConfig(): ProductConfig {
  return useContext(ProductConfigContext);
}

export { type AdminConfig } from "@redotech/redo-onboarding-api/schema/get-progress";
export { type ShippingFulfillmentAvailability } from "@redotech/redo-onboarding-api/schema/shipping-fulfillment/shipping-fulfillment-config";
